import { PropsWithChildren } from 'react';
import { BooleanFeature } from '../ui';

export const SupplierDemoWrapper = ({ children }: PropsWithChildren) => {
  return (
    <BooleanFeature flipCondition featureFlag="demo" defaultValue={false}>
      {children}
    </BooleanFeature>
  );
};
